import {BackendTagField} from '../../../configuration/backendFileds/backendFileld.config';
import {useEffect} from 'react';

const useReferenceImageUpload = (autoProjectState, setState, onDoneProcess, uploadCounter, numberOfFiles, data_project_id, deleteClass, isCanAddFile = true, setOpenModal, class_id) => {

    /**
     * addClass - when user wants to add class
     */
    const addClass = async () => {
        let isCloseModal = true;
        let index = -10;

        if (isCanAddFile) {
            index = autoProjectState.classes.findIndex((item) => item.tag_id === class_id);
            const classNameIndex = class_id > -1 ? autoProjectState.classes.findIndex((cl) => (cl[BackendTagField.name] === autoProjectState.className && cl[BackendTagField.id] !== autoProjectState.classes[index][BackendTagField.id]))
                : autoProjectState.classes.findIndex((cl) => (cl[BackendTagField.name] === autoProjectState.className));

            if (!autoProjectState.className) {
                setState({classError: 'Missing class name'});
                isCloseModal = false;
            } else if ((classNameIndex > -1 && classNameIndex !== index)) {
                setState({classError: 'Class name already exist'});
                isCloseModal = false;
            } else if (uploadCounter !== numberOfFiles) {
                setState({uploadClassError: 'Wait till all images will be uploaded'});
                isCloseModal = false;
            } else {
                const tag = {[BackendTagField.name]: autoProjectState.className};
                const copyClasses = JSON.parse(JSON.stringify(autoProjectState.classes));
                const copyTags = JSON.parse(JSON.stringify(autoProjectState.tags));

                if (class_id > -1) {
                    class_id = index !== -10 ? index : class_id;
                    BackendTagField.id in copyClasses[class_id] && (tag[BackendTagField.id] = copyClasses[class_id][BackendTagField.id]);
                    copyClasses[class_id][BackendTagField.name] = autoProjectState.className;
                    tag[BackendTagField.isReadyForFineTune] = copyClasses[class_id][BackendTagField.isReadyForFineTune];

                }
                onDoneProcess(
                    'success',
                    setState,
                    {
                        classes: copyClasses,
                        className: '',
                        tags: copyTags.filter((tag) => BackendTagField.id in tag),
                        activeEditId: -1,
                        activeAddClass: -1,
                        closeEditClass: true,
                        classFiles: [],
                        classMainError: '',
                        filesDict: autoProjectState.filesDict
                    },
                    tag,
                    class_id > -1 ? index !== -10 : true,
                    data_project_id);
            }
            setOpenModal(!isCloseModal);
        }

    };

    /**
     * deleteClassFunc - when user wants to delete class
     */
    const deleteClassFunc = () => {
        if (uploadCounter !== numberOfFiles) {
            setState({uploadClassError: 'Wait till all images will be uploaded'});
        } else {
            const copyClasses = JSON.parse(JSON.stringify(autoProjectState.classes));
            const copyTags = JSON.parse(JSON.stringify(autoProjectState.tags));
            const newState = {
                classes: copyClasses,
                className: '',
                deletedTags: autoProjectState.deletedTags,
                tags: copyTags,
                activeAddClass: -1,
                closeEditClass: true,
                activeEditId: -1,
                classFiles: [],
                classMainError: '',
                filesDict: autoProjectState.filesDict
            };

            deleteClass(copyClasses[class_id], newState);
        }
    };

    const removeImagesFromClass = () => {
        const copyClasses = JSON.parse(JSON.stringify(autoProjectState.classes));

        copyClasses[autoProjectState.activeAddClass].imageList = [];
        setState(
            {
                className: '',
                classes: copyClasses,
                activeAddClass: -1,
                activeEditId: -1,
                closeEditClass: true,
                classFiles: [],
                classMainError: ''
            }
        );
    };

    useEffect(() => {
        if (autoProjectState.activeAddClass > -1 && autoProjectState.activeAddClass === class_id) {
            numberOfFiles > 0 ? addClass() : removeImagesFromClass();
        }
    }, [class_id, autoProjectState.activeAddClass, numberOfFiles, autoProjectState.uploadClassError]);

    return {addClass, deleteClassFunc};
};

export default useReferenceImageUpload;
